import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import SliderComponent from "./sliderComponent.js"
import { buildEngineLabel, engineDefault } from "../moreFiltersContainer/engineFilterConfig"

class EngineInput extends Component {
  constructor(props) {
    super(props)
    this.state = {
      currentRange: this.props.currentRange,
      labelRange: this.props.currentRange
    }
  }

  componentDidMount() {
    //we might grab the URL here on mount. but I don't know if we should or not.
    //might pass these down as defaultValue props.
  }

  componentDidUpdate(prevProps) {
    if (prevProps.currentRange !== this.props.currentRange) {
      if (this.props.currentRange !== this.state.currentRange) {
        this.setState({
          currentRange: this.props.currentRange,
          labelRange: this.props.currentRange
        })
      }
    }
  }

  handleLabelChange = values => {
    this.setState({
      labelRange: values
    })
  }

  handleEngineChange = values => {
    this.setState({
      currentRange: values
    })
    this.props.onChange(values)
  }

  render() {
    const { currentRange, labelRange } = this.state
    
    const { showFeedbackLabel, defaultMax, defaultMin } = this.props

    return (
      <React.Fragment>
        {showFeedbackLabel && (
          <div className="slider-label">
            {buildEngineLabel(labelRange)}
          </div>
        )}
        <SliderComponent
          domain={[defaultMin, defaultMax]}
          currValues={currentRange}
          onUpdate={this.handleLabelChange}
          steps={50}
          onSlideEnd={this.handleEngineChange}
        />
      </React.Fragment>
    )
  }
}

export default withRouter(EngineInput)

EngineInput.defaultProps = {
  showFeedbackLabel: true,
  defaultMin: engineDefault[0],
  defaultMax: engineDefault[1],
  defaultLabel: "Engine Height",
  currentRange: [engineDefault[0], engineDefault[1]],
  onChange: function() {}
}
